<template>
  <div class="parent-modal">
    <div class="modal">
      <slot name="icon"></slot>
      <slot name="content"></slot>
      <slot name="custom-message"></slot>
      <div class="flex w-full gap-5">
        <slot name="first-btn"></slot>
        <slot name="second-btn"></slot>
        <slot name="third-btn"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  data() {
    return {};
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_variables.scss";
.parent-modal {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 999999;
}
.modal {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: fixed;
  z-index: 999999;
  background-color: #fff;
  right: 50%;
  transform: translate(50%, -50%);
  top: 50%;
  padding: 12px;
  border-radius: 5px;
  box-shadow: 0px 8px 21px #0000001a;
  min-width: 560px;
 
  .modal-content {
    color: #212121;
    font-size: 18px;
    line-height: 33px;
    margin-bottom: 12px;
    font-weight: bold;
    text-align: start;
    align-self: start;
    img {
      max-height: 273px;
      // max-height: 80vh;
      display: block;
      margin: auto;
      margin-bottom: 16px;
      border-radius: 4px;
    }
    .skeleton-loading {
      margin: auto;
      margin-bottom: 16px;
    }
    p {
      font-size: 12px;
      font-weight: 600;
      line-height: 22px;
      text-align: left;
    }
  }
  .modal-phone {
    text-align: left;
    width: 100%;
    background: #21212114;
    border-radius: 4px;
    padding: 4px 16px;
    color: #212121;
    display: flex;
    align-items: center;
    font-weight: bold;
    svg {
      margin: 0px;
    }
  }
  .buttons {
    column-gap: 12px;
    display: flex;
    width: 100%;
  }
  button {
    border: none;
    background-color: $mainColor2;
    padding: 6px 24px;
    font-weight: bold;
    font-size: 14px;
    line-height: 21px;
    border-radius: 6px;
    height: 38px;
    cursor: pointer;
    color: $mainColor1;
    .loader {
      border: 2px solid $mainColor1;
      border-radius: 50%;
      border-top: 2px solid #fff;
    }
  }
  .first-btn {
    background-color: $mainColor1;
    color: #fff;
  }
  .third-btn {
    background-color: #fff;
    border: solid 1px $mainColor1;
  }
  .close-icon {
    width: 100%;
    text-align: right;
    margin-left: 0px;
    cursor: pointer;
    height: 16px;
  }
}
</style>